import { haveAnyValue } from 'src/utils/utilitiesV2'

const getPOSSelected = (posIds: string, options: ISelect[]): ISelect[] => {
  if (!haveAnyValue(posIds)) return []

  const posIdArray = posIds.split(',').map(id => Number(id.trim()))
  return options.filter(option => posIdArray.includes(Number(option.value)))
}

const processPOSSelected = (posSelected: ISelect, options: ISelect[]): ISelect[] => {
  const exists = options.find(option => option.value === posSelected.value)
  if (!exists) return [...options, posSelected]
  return options
}

const removePOS = (posRemoved: ISelect, options: ISelect[]): ISelect[] => {
  const index = options.findIndex(option => option.value === posRemoved.value)
  if (index !== -1) {
    const newOptions = [...options]
    newOptions.splice(index, 1)
    return newOptions
  }
  return options
}
export { getPOSSelected, processPOSSelected, removePOS }
